import React from 'react';
import classnames from 'classnames';
import { Layout, Flex } from 'app/components/base/Layout';
import Icon from 'app/components/base/Icon';
import Segment from './Segment';

import style from './style.css';

// Constants
const messages = {
  fromLabel: { id: 'TRIP_DETAILS.FROM' },
  toLabel: { id: 'TRIP_DETAILS.TO' },
  departing: { id: 'TRIP_DETAILS.DEPARTING' },
  returning: { id: 'TRIP_DETAILS.RETURNING' },
  routeDetailsLabel: { id: 'TRIP_DETAILS.MOBILE.ROUTE_DETAILS' }
};

// Because of #1120, return arrow is now reversed.
const directionPropsMap = {
  departing: {
    color: '#009245',
    icon: 'departureArrow'
  },
  returning: {
    color: '#ff9c00',
    icon: 'returnArrowReverse'
  }
};

/**
 * Renders the route details section that specifies dates and locations for
 * the trip. It can be used both for normal and return trip.
 * TODO: Add callback for routeDetails button when connecting.
 */
const TripDirection = ({
  showDateTimes,
  fromAddress,
  toAddress,
  fromDistance,
  fromStation,
  toDistance,
  toStation,
  plainArrivalDatetime,
  plainDepartureDatetime,
  direction,
  cancelled,
  fromIataCode,
  toIataCode,
  fltSupport,
  flightNumber,
  airline,
  // onClickRouteDetails
}) => {
  const labelPrefix = direction === 'departing' || direction === 'returning' ?
    messages[direction] : null;
  const modifiers = {
    [style['trip--cancelled']]: cancelled
  };

  return (
    <Layout
      className={classnames(style.container, modifiers)}
      size="100"
      align="start stretch"
      direction="row"
      nowrap
    >
      <Layout size="50" className={style.right} align="space-between stretch" direction="column">
        <Segment
          address={fromAddress}
          datetime={plainDepartureDatetime}
          showDateTimes={showDateTimes}
          showTripTime={!fltSupport}
          labelPrefix={labelPrefix}
          labelMessage={messages.fromLabel}
          distance={fromDistance}
          station={fromStation}
          color={direction && directionPropsMap[direction].color}
          flightCode={fromIataCode ? `${airline} ${flightNumber}` : ''}
        />
      </Layout>
      <Flex className={style.separator} size="noshrink">
        <div className={style.line}></div>
        <Icon
          family="mozio"
          className={style.icon}
          style={{ fill: direction && directionPropsMap[direction].color }}
        >
          {direction && directionPropsMap[direction].icon}
        </Icon>
      </Flex>
      <Layout size="50" className={style.left} align="space-between stretch" direction="column">
        <Segment
          address={toAddress}
          datetime={plainArrivalDatetime}
          showDateTimes={showDateTimes}
          showTripTime={!fltSupport}
          labelMessage={messages.toLabel}
          distance={toDistance}
          station={toStation}
          color={direction && directionPropsMap[direction].color}
          flightCode={toIataCode ? `${airline} ${flightNumber}` : ''}
        />
      </Layout>

      {/* TODO: add route details screen <Layout>
        <Button bordered small nocaps onClick={onClickRouteDetails}>
          <FormattedMessage {...messages.routeDetailsLabel} />
        </Button>
      </Layout>*/}

    </Layout>
  );
};

// TODO: move to Flow types
// TripDirection.propTypes = {
//   showDateTimes: PropTypes.bool,
//   fromAddress: PropTypes.string.isRequired,
//   toAddress: PropTypes.string.isRequired,
//   fromDistance: PropTypes.string,
//   fromStation: PropTypes.object,
//   toDistance: PropTypes.string,
//   toStation: PropTypes.object,
//   plainDepartureDatetime: PropTypes.string,
//   plainArrivalDatetime: PropTypes.string,
//   direction: PropTypes.oneOf(['departing', 'returning']),
//   onClickRouteDetails: PropTypes.func,
//   cancelled: PropTypes.bool
// };

TripDirection.defaultProps = {
  showDateTimes: false
};

export default TripDirection;
